import { useCreateEntity } from '@abaninja/util-store';

import { addComment } from '../documents';

export const useDocumentCommentStore = () => useCreateEntity(addComment);
